import React,{useEffect,useState} from 'react';
import Select from 'react-select';
import { reportAPI, publisherAPI, projectAPI } from '../../utils/api';
import { ComposedChart,Bar,Line,XAxis,YAxis,Tooltip,Legend,CartesianGrid,ResponsiveContainer } from 'recharts';
import Swal from 'sweetalert2';

export default function WorkOrdersAnalyticsPage(){
  const today=new Date(); const oneYearAgo=new Date(today.getFullYear()-1,today.getMonth(),1);
  const [start,setStart]=useState(oneYearAgo.toISOString().substring(0,10));
  const [end,setEnd]=useState(today.toISOString().substring(0,10));
  const [gran,setGran]=useState('month');
  const [data,setData]=useState([]);
  const [kpis,setKpis]=useState({});
  const metricOptions=[{value:'orders',label:'Orders'},{value:'qty',label:'Quantity'},{value:'value',label:'Value'}];
  const [metrics,setMetrics]=useState(['orders','qty','value']);
  const load=async()=>{
    try{
      const [sum,ts]=await Promise.all([
        reportAPI.workOrderSummary({start,end}),
        reportAPI.workOrderTimeSeries({start,end,granularity:gran,fields:metrics.join(',')})
      ]);
      setKpis(sum.data.kpis||{});
      setData(ts.data||[]);
    }catch(e){Swal.fire('Error',e.message,'error');}
  };
  useEffect(()=>{load();},[start,end,gran]);
  return (
    <div className="eduss-report-page">
      <h2>Work-Orders Analytics</h2>
      <div style={{display:'flex',gap:12,flexWrap:'wrap',alignItems:'center',marginBottom:12}}>
        <div><label>Start </label><input type="date" value={start} onChange={e=>setStart(e.target.value)}/></div>
        <div><label>End </label><input type="date" value={end} onChange={e=>setEnd(e.target.value)}/></div>
        <select value={gran} onChange={e=>setGran(e.target.value)}>
          <option value="day">Day</option><option value="week">Week</option><option value="month">Month</option>
        </select>
        <Select isMulti options={metricOptions} value={metricOptions.filter(o=>metrics.includes(o.value))} onChange={sel=>setMetrics(sel.map(o=>o.value))} styles={{container:(p)=>({...p,minWidth:240})}}/>
        <button className="eduss-global-table-btn" onClick={load}>Refresh</button>
      </div>
      <div style={{display:'flex',gap:16,flexWrap:'wrap',marginBottom:24}}>
        <KpiCard title="Total Orders" value={kpis.totalOrders}/>
        <KpiCard title="Total Quantity" value={kpis.totalQuantity}/>
        <KpiCard title="Total Value" value={kpis.totalValue} fmt/>
      </div>
      <div style={{width:'100%',height:400,marginTop:16}}>
        <ResponsiveContainer>
          <ComposedChart data={data} margin={{top:20,right:30,left:0,bottom:5}}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="period" />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" />
            <Tooltip />
            <Legend />
            {metrics.includes('qty') && <Bar yAxisId="left" dataKey="qty" name="Quantity" fill="#8884d8" />}
            {metrics.includes('orders') && <Line yAxisId="right" type="monotone" dataKey="orders" name="Orders" stroke="#ff7300" />}
            {metrics.includes('value') && <Line yAxisId="right" type="monotone" dataKey="value" name="Value" stroke="#82ca9d" />}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function KpiCard({title,value,fmt}){
  const nf=new Intl.NumberFormat('en-US');
  return(<div style={{flex:'1 0 180px',background:'#f6f8fa',padding:16,borderRadius:8}}>
    <div style={{fontSize:14,color:'#666'}}>{title}</div>
    <div style={{fontSize:24,fontWeight:'bold'}}>{fmt?nf.format(value||0):(value||0)}</div>
  </div>);
}

function ComposedChartComp({data}){
  const nf=new Intl.NumberFormat('en-US');
  return(
    <ComposedChart data={data} margin={{top:20,right:30,left:0,bottom:5}}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="period"/>
      <YAxis yAxisId="left" orientation="left" stroke="#8884d8"/>
      <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" />
      <Tooltip formatter={(v)=>nf.format(v)}/>
      <Legend />
      <Bar yAxisId="left" dataKey="qty" name="Quantity" fill="#8884d8" />
      <Line yAxisId="right" type="monotone" dataKey="value" name="Value" stroke="#82ca9d" />
    </ComposedChart>
  );
}
